export default "__VITE_ASSET__f92baff4__"